import { useTranslation } from 'react-i18next';

export default function MissingFeature({ what }: { what: string }) {
  const { t } = useTranslation();
  return (
    <div className='p-5 text-zinc-100 text-xl font-medium'>
      {t('components.missingFeature.text', { what })}
    </div>
  );
}
